export const profileMainBox = {
  direction: "column",
  w: "100%",
  h: { base: "87vh", md: "100%" },
  p: { base: 0, md: "1rem" },
  maxW: "975px",
  margin: "0 auto",
  mb: { base: "4.2rem", md: "0.4rem" },
  overflowY: "scroll",
};

export const tabListStyle = {
  justifyContent: "center",
  w: { base: "100%", md: "70%" },
  maxW: "483px",
  m: "auto",
  border: "none",
};

export const emptyCameraStyles = {
  color: "gray",
  fontSize: "7rem",
  border: "1px solid gray",
  borderRadius: "50%",
  p: "1rem",
};

export const profileDetailMain = {
  alignItems: "center",
  width: "100%",
  gap: { base: "1rem", md: "4rem" },
  p: "1rem",
  pl: { lg: "5rem" },
  pb: { lg: "0" },
};

export const profileButtonMain = {
  flexDir: { base: "column", md: "row" },
  gap: "0.5rem",
  flexWrap: "wrap",
  maxW: "613px",
  padding: "1rem",
};

export const profileUsernameStyle = {
  fontSize: "2xl",
  fontWeight: "bold",
  mb: { base: 2, md: 0 },
  align: "center",
  gap: "4",
  width: { base: "auto", md: "40%" },
};

export const userPostLengthStyle = {
  w: "100%",
  maxW: "400px",
  justifyContent: "space-between",
  p: "0.5rem 0",
};

export const pcBioStyle = {
  flexDir: "column",
  w: "100%",
  gap: "0.4rem",
  pt: 0,
  minW: "300px",
};

export const profileFollowedByStyle = {
  fontSize: "sm",
  cursor: "pointer",
  p: "0.5rem 0rem!important",
  display: { base: "none", md: "flex" },
};

export const mobileBioStyle = {
  flexDir: "column",
  w: "100%",
  display: { base: "flex", md: "none" },
  gap: "0.1rem",
  p: "0.5rem 1rem",
  pt: 0,
};

export const mobileUserLength = {
  w: "100%",
  justifyContent: "space-around",
  p: "1rem",
  display: { base: "flex", md: "none" },
};

export const profileImageStyle = {
  objectFit: "fill",
  h: "100%",
  w: "100%",
  maxW: "293px",
  maxH: "293px",
};

export const profileHoverStyle = {
  pos: "absolute",
  top: "0",
  justifyContent: "center",
  w: "100%",
  alignItems: "center",
  height: "100%",
  bg: "#00000069",
  gap: "3rem",
  color: "white",
  maxW: "293px",
  maxH: "293px",
};
